import api from '.';

const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    paymentIntent: builder.mutation({
      query: (params) => ({
        url: '/payment-intents',
        method: 'POST',
        body: params
      }),

    })
  })
});

export default paymentApi;
export const { usePaymentIntentMutation } = paymentApi;
